import { Checkbox, Modal, notification } from "antd";
import { useState } from "react";
import { billingActiveClientsApi, chooseFreePlanApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";

/**
 * Switching to the Free plan. With more active clients than it allows, the doctor first picks
 * which clients stay active (the rest are deactivated). Returns chooseFree, saving and the picker modal.
 */
export const useFreePlan = (onDone) => {
    const [saving, setSaving] = useState(false)
    const [keep, setKeep] = useState(null)

    const chooseFree = (keepActive) => {
        setSaving(true)
        chooseFreePlanApi(keepActive)
            .then((res) => {
                notification.success({ message: res.data.message, duration: 8 })
                onDone && onDone()
            })
            .catch((err) => {
                const data = err?.response?.data
                if (data?.error === 'too_many_clients') {
                    billingActiveClientsApi()
                        .then((res) => setKeep({ limit: data.limit, clients: res.data.data, selected: [] }))
                        .catch((e) => notification.error({ message: apiErrorMessage(e) }))
                } else {
                    notification.error({ message: apiErrorMessage(err) })
                }
            })
            .finally(() => setSaving(false))
    }

    const modal = keep && (
        <Modal
            open
            title={`The Free plan allows ${keep.limit} active clients`}
            onCancel={() => setKeep(null)}
            okText={`Keep ${keep.selected.length} active and continue`}
            okButtonProps={{ disabled: keep.selected.length === 0, loading: saving }}
            onOk={() => { chooseFree(keep.selected); setKeep(null) }}
        >
            <p>
                You have {keep.clients.length} active clients. Choose up to {keep.limit} to keep active.
                The others are deactivated; you can activate them again after upgrading.
            </p>
            <Checkbox.Group
                value={keep.selected}
                onChange={(selected) => selected.length <= keep.limit && setKeep({ ...keep, selected })}
                style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
            >
                {keep.clients.map((client) => (
                    <Checkbox
                        key={client.id}
                        value={client.id}
                        disabled={!keep.selected.includes(client.id) && keep.selected.length >= keep.limit}
                    >
                        {client.name} <span className="text-muted">({client.email})</span>
                    </Checkbox>
                ))}
            </Checkbox.Group>
        </Modal>
    )

    return { chooseFree, saving, modal }
}
